import moment from "moment";

export const timeTypeOptions: any = [
  // {
  //   value: 'date',
  //   nameEn: 'Day',
  //   nameCN: '日',
  // },
  // {
  //   value: 'week',
  //   nameEn: 'Week',
  //   nameCN: '周',
  // },
  // {
  //   value: 'month',
  //   nameEn: 'Month',
  //   nameCN: '月',
  // },
  
  {
    value: 'dynamic',
    nameEn: 'Dynamic Time',
    nameCN: '动态日期'
  },
  {
    value: 'static',
    nameEn: 'Static Time',
    nameCN: '静态日期'
  },
];

function momentFormat(date: any, format = 'YYYY-MM-DD') {
  if (typeof date === 'string') {
    date = moment(date);
  }
  return date?.format(format) || '';
}

export const timeTypeObj: any = {
  'date': [
    {
      nameEn: 'Yesterday',
      nameCN: '昨天',
      getValue: () => [moment().subtract(1, 'day'), moment().subtract(1, 'day')],
      cycle: 'date1',
    },
    {
      nameEn: 'Last 7 Days',
      nameCN: '最近7天',
      getValue: () => [moment().subtract(7, 'day'), moment().subtract(1, 'day')],
      cycle: 'date7',
    },
    {
      nameEn: 'Last 14 Days',
      nameCN: '最近14天',
      getValue: () => [moment().subtract(14, 'day'), moment().subtract(1, 'day')],
      cycle: 'date14',
    },
    {
      nameEn: 'Last 30 Days',
      nameCN: '最近30天',
      getValue: () => [moment().subtract(30, 'day'), moment().subtract(1, 'day')],
      cycle: 'date30',
    },
  ],
  'week': [
    {
      nameEn: 'Last Week',
      nameCN: '上周',
      getValue: () => [moment().weekday(-7 * 1), moment().weekday(-1)],
      cycle: 'week1',
    },
    {
      nameEn: 'Last 4 Weeks',
      nameCN: '最近4周',
      getValue: () => [moment().weekday(-7 * 4), moment().weekday(-1)],
      cycle: 'week4',
    },
    {
      nameEn: 'Last 12 Weeks',
      nameCN: '最近12周',
      getValue: () => [moment().weekday(-7 * 12), moment().weekday(-1)],
      cycle: 'week12',
    },
  ],
  'month': [
    {
      nameEn: 'Last Month',
      nameCN: '上月',
      getValue: () => [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
      cycle: 'month1',
    },
    {
      nameEn: 'Last 3 Months',
      nameCN: '最近3个月',
      getValue: () => [moment().subtract(3, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
      cycle: 'month3',
    },
    {
      nameEn: 'Last 6 Months',
      nameCN: '最近6个月',
      getValue: () => [moment().subtract(6, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
      cycle: 'month6',
    },
  ],
};